import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from '../Dialog/InfoDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  infoCard: {
    width: '100%',
    height: 56,
    padding: "19px 16px",
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'none',
    border: '1px solid lightgray'
  },
  infoCardTitle: {
    color: '#6b778c',
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: 600,
    letterSpacing: 'normal'
  },
  infoCardIcon: {
    fontSize: 14,
    margin: '-2px 3px 0px 3px',
    color: '#A8A8A8',
    //float: 'right',
    cursor: 'pointer'
    // marginTop: 4
  },
  value: {
    fontSize: 22,
    textTransform: 'uppercase',
    fontWeight: 300,
    textAlign: 'right'
    //float:'right'
  },
  first: {
    //width:'100%'
  },
  last: {
    //width:'70%'
    marginLeft: '1em'
  }
}));
const TopCard = (props) => {
  const { title,widthNone,heightNone, cardValue, color, infoIcon, infoTitle, infoText } = props;
  const classes = useStyles();
  const [infoOpen, setInfoOpen] = React.useState(false);
  const handleInfoOpen = () => {
    setInfoOpen(true);
  }
  const handleInfoClose = () => {
    setInfoOpen(false);
  }
  return (
    <>
      <Paper className={classes.infoCard} style={{width:widthNone?'auto':'100%',height:heightNone?'auto':'56px'}} >
        <div className={classes.first}>
          <Typography variant="subtitle2" className={classes.infoCardTitle}>
            {title}<span>{infoIcon && <InfoOutlinedIcon onClick={handleInfoOpen} className={classes.infoCardIcon} />}</span>
          </Typography>
        </div>
        <div className={classes.last}>
          <Typography variant="subtitle2" className={classes.value} style={{ color: color ? color : 'inherit' }}>
            {cardValue}
          </Typography>
        </div>

        {/* <Typography variant="subtitle2" className={classes.infoCardTitle}>
            {title}<span>{infoIcon && <InfoOutlinedIcon onClick={handleInfoOpen} className={classes.infoCardIcon} />}</span>
            <Typography variant="subtitle2" className={classes.value} style={{color:color?color:'inherit'}}>
            {cardValue}
            </Typography>
            </Typography> */}
        {/* <Typography variant="subtitle2" className={classes.value} style={{color:color?color:'inherit'}}>
            {cardValue}
            </Typography> */}
      </Paper>
      {infoOpen && <InfoDialog confirmOpen={infoOpen} confirmTitle={infoTitle} confirmMessage={infoText} onClose={handleInfoClose} />}
    </>
  );
}
export default TopCard;